

import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../websitecomponents/redux/EndPoint/endpoint";
import { useNavigate } from "react-router-dom";

const ReSellerProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const token = localStorage.getItem("ResellerTokenData");
    console.log("TOKEN =>", token);

    if (!token) {
      console.log("No token found");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(endPoint.ReSellerProfile, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.success && res.data?.reseller) {
        setProfile(res.data.reseller);
      } else {
        setProfile(null);
      }
    } catch (err) {
      console.log("ERROR =>", err.response?.data || err.message);
      setProfile(null);
    } finally {
      setLoading(false);
    }
  };


  if (loading) {
    return <p className="px-6 py-6 text-base">Loading profile...</p>;
  }

  if (!profile) {
    return (
      <p className="px-6 py-6 text-base text-red-500">No profile data found</p>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
      <form className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
        {/* Basic Details */}
        <ReadOnlyInput label="Full Name" value={profile.fullName} />
        <ReadOnlyInput label="Email Address" value={profile.email} />
        <ReadOnlyInput label="Phone Number" value={profile.phone} />

        {/* Bank Section */}
        <h3 className="md:col-span-2 text-lg font-semibold mt-8">
          Commission Payout Details
        </h3>

        <ReadOnlyInput
          label="Account Holder Name"
          value={profile.bankDetails?.holderName}
        />
        <ReadOnlyInput
          label="Account Number"
          value={profile.bankDetails?.accountNumber}
        />
        <ReadOnlyInput
          label="IFSC Code"
          value={profile.bankDetails?.ifscCode}
        />
        <ReadOnlyInput
          label="Bank Name"
          value={profile.bankDetails?.bankName}
        />

        {/* Button */}
        <div className="md:col-span-2 flex justify-start mt-6">
          <button
            type="button"
            onClick={() => navigate("/reseller/editProfile")}
            className="px-6 py-3 bg-orange-600 text-white text-base rounded-lg hover:bg-orange-700"
          >
            Edit Profile
          </button>
        </div>
      </form>
    </div>
  );
};

// 🔹 Reusable Input
const ReadOnlyInput = ({ label, value }) => (
  <div>
    <p className="text-sm sm:text-base text-gray-500 mb-1">{label}</p>
    <input
      type="text"
      value={value || ""}
      readOnly
      className="w-full border-b border-gray-300 py-2 text-base bg-gray-50 focus:outline-none"
    />
  </div>
);

export default ReSellerProfile;
